/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Update wishlist button variant when product variant changes */
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input || input.name !== 'id') return;
  var variantId = input.value;
  var btn = document.querySelector('.kelab-atc-row .kelab-wishlist-btn');
  if (btn && variantId) btn.dataset.variantId = variantId;
});


// KELAB FAQ — accordion for both <details> and button markup
(function () {
  function initDetails() {
    var items = document.querySelectorAll('details.kelab-faq-item');
    if (!items.length) return;
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function initButtons() {
    var items = document.querySelectorAll('.kelab-faq-item:not(details)');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.kelab-faq-question');
      if (!btn || btn.dataset.kelabBound) return;
      btn.dataset.kelabBound = '1';
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (i) {
          i.classList.remove('open');
          var b = i.querySelector('.kelab-faq-question');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDetails();
    initButtons();
  });
})();

// KELAB FAQ — exclusive accordion for native <details>
(function () {
  function bind(sel) {
    var items = document.querySelectorAll(sel);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    bind('details.kelab-faq-item');
  });
})();

// Auto-select Chrome or Silver variant — Chrome collection only
(function() {
  var body = document.body;
  var isChrome = body.classList.contains('Template--collection') &&
    (window.location.pathname.indexOf('/collections/chrome') !== -1);

  if (!isChrome) return;

  var PREFERRED = ['chrome', 'silver'];

  function autoSelectVariant(card) {
    if (card._kelabAutoSelected) return;

    var radios = Array.from(card.querySelectorAll('.ProductCard__ColorSwatchRadio'));
    if (!radios.length) return;

    var target = null;
    for (var p = 0; p < PREFERRED.length; p++) {
      for (var r = 0; r < radios.length; r++) {
        var val = (radios[r].value || '').toLowerCase();
        if (val.indexOf(PREFERRED[p]) !== -1) {
          target = radios[r];
          break;
        }
      }
      if (target) break;
    }

    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));

      // Sync the custom dropdown button text and selected state
      var cardEl = card.closest('.kelab-tab-product');
      if (cardEl) {
        // Find the dropdown that corresponds to this radio group
        var radioName = target.name;
        var dropdowns = cardEl.querySelectorAll('.kelab-variant-select-wrap');
        dropdowns.forEach(function(wrap) {
          var btn = wrap.querySelector('.kelab-variant-custom-btn');
          var list = wrap.querySelector('.kelab-variant-custom-list');
          if (!btn || !list) return;

          // Check if this dropdown contains an option matching our target value
          var options = Array.from(list.querySelectorAll('.kelab-variant-custom-option'));
          var matchingOption = null;
          for (var i = 0; i < options.length; i++) {
            var optText = (options[i].textContent || '').trim().toLowerCase();
            for (var p2 = 0; p2 < PREFERRED.length; p2++) {
              if (optText.indexOf(PREFERRED[p2]) !== -1) {
                matchingOption = options[i];
                break;
              }
            }
            if (matchingOption) break;
          }

          if (matchingOption) {
            // Update button label
            if (btn.childNodes[0]) {
              btn.childNodes[0].nodeValue = matchingOption.textContent.trim();
            } else {
              btn.insertBefore(document.createTextNode(matchingOption.textContent.trim()), btn.firstChild);
            }
            // Update selected state in list
            options.forEach(function(o) {
              o.classList.toggle('is-selected', o === matchingOption);
            });
          }
        });
      }
    }

    card._kelabAutoSelected = true;
  }

  function runAll() {
    document.querySelectorAll('.kelab-tab-product .ProductCard').forEach(autoSelectVariant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  var grid = document.querySelector('.kelab-tabs-grid');
  if (grid) {
    new MutationObserver(function() { runAll(); }).observe(grid, { childList: true, subtree: true });
  }

  setTimeout(runAll, 500);
  setTimeout(runAll, 1500);
})();

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  var mediaId = variant && variant.featured_media
    ? variant.featured_media.id
    : (variant && variant.featured_image ? variant.featured_image.id : null);
  if (!mediaId) return;

  var mapScript = document.querySelector('[data-product-media-id-index-json]');
  if (!mapScript) return;

  var index;
  try {
    index = JSON.parse(mapScript.textContent).media_id_index['id_' + mediaId];
  } catch (e) { return; }
  if (index === undefined) return;

  var sectionProductElement = document.querySelector('section-product');
  if (sectionProductElement && sectionProductElement.productSlideshow) {
    sectionProductElement.productSlideshow.selectCell(index);
  }
});

// ============================================================
// KELAB — Collection-model pre-selection for product cards (v2, robust)
// ------------------------------------------------------------
// Reads data-kelab-target-model / data-kelab-variant-map as STATIC
// HTML attributes rendered directly by Liquid in snippets/product-card.liquid
// (not JS-set via inline <script>), so this keeps working even when a
// third-party app (e.g. the Okendo reviews widget) re-renders product
// cards client-side a few seconds after page load -- a re-render replaces
// the card's HTML (attributes survive, since they're just markup) but does
// NOT re-execute any inline <script> tags that were inside the old markup,
// which is why the previous per-card <script> approach silently stopped
// working for most cards a few seconds after page load.
// ============================================================
(function () {
  function getProductLinks(card) {
    return Array.prototype.filter.call(card.querySelectorAll('a[href]'), function (a) {
      var href = a.getAttribute('href') || '';
      return href.indexOf('/products/') !== -1;
    });
  }

  function resolveUrl(card, caseTypeVal) {
    var targetModel = (card.getAttribute('data-kelab-target-model') || '').toLowerCase();
    if (!targetModel) return null;
    var map = [];
    try {
      map = JSON.parse(card.getAttribute('data-kelab-variant-map') || '[]');
    } catch (e) {
      return null;
    }
    var modelOnly = null;
    for (var i = 0; i < map.length; i++) {
      var row = map[i];
      var rowModel = (row[0] || '').toLowerCase();
      var rowCase = (row[1] || '').toLowerCase();
      if (rowModel === targetModel) {
        if (caseTypeVal && rowCase === caseTypeVal.toLowerCase()) return row[2];
        if (!modelOnly) modelOnly = row[2];
      }
    }
    return modelOnly;
  }

  function applyDefaultLink(card) {
    if (card.dataset.kelabUserSelectedUrl) return;
    var url = resolveUrl(card, null);
    if (url) {
      getProductLinks(card).forEach(function (link) {
        link.href = url;
      });
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ProductCard[data-kelab-target-model]').forEach(applyDefaultLink);
    if (root && root.matches && root.matches('.ProductCard[data-kelab-target-model]')) {
      applyDefaultLink(root);
    }
  }

  document.body.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.classList || !radio.classList.contains('ProductCard__ColorSwatchRadio')) return;
    var card = radio.closest('.ProductCard[data-kelab-target-model]');
    if (!card) return;
    var url = resolveUrl(card, radio.value);
    if (!url) return;
    var apply = function () {
      getProductLinks(card).forEach(function (link) {
        link.href = url;
      });
      card.dataset.kelabUserSelectedUrl = url;
    };
    apply();
    // Re-apply on the next tick so this wins even if another listener on
    // the same 'change' event (e.g. the theme's generic swatch handler)
    // also rewrites these hrefs using its own non-model-aware URL.
    setTimeout(apply, 0);
  });

  scan();

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();